export default __webpack_public_path__ + "static/media/H0001.0f0dcba7.png";